var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.8125C4.58274 1.8125 1.8125 4.58274 1.8125 8C1.8125 11.4173 4.58274 14.1875 8 14.1875C11.4173 14.1875 14.1875 11.4173 14.1875 8C14.1875 4.58274 11.4173 1.8125 8 1.8125ZM0.6875 8C0.6875 3.96142 3.96142 0.6875 8 0.6875C12.0386 0.6875 15.3125 3.96142 15.3125 8C15.3125 12.0386 12.0386 15.3125 8 15.3125C3.96142 15.3125 0.6875 12.0386 0.6875 8ZM8.5625 7.4375V4.25C8.5625 3.93934 8.31066 3.6875 8 3.6875C7.68934 3.6875 7.4375 3.93934 7.4375 4.25V8C7.4375 8.31066 7.68934 8.5625 8 8.5625H10.625C10.9357 8.5625 11.1875 8.31066 11.1875 8C11.1875 7.68934 10.9357 7.4375 10.625 7.4375H8.5625Z",
    fill: "#3E3E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.df967206eb5dc5922b6ec691debc84eb.svg";
export { ForwardRef as ReactComponent };